import { AskAlpharunModal } from "@repo/ui/chat/askAlpharunModal";
import type { FC } from "react";
import { ResearchAgentChatView } from "./researchAgentChatView.js";
import type { ResearchAgentProps } from "./researchAgentContext.js";
import { ResearchAgentHistoryView } from "./researchAgentHistoryView.js";

export interface ResearchAgentExpandedModalProps {
  researchAgent: ResearchAgentProps;
}

/**
 * The expanded (near-fullscreen) research agent chat: a history rail beside
 * the conversation, in a dismissable modal driven by the provider's
 * `isModalOpen` state.
 */
export const ResearchAgentExpandedModal: FC<
  ResearchAgentExpandedModalProps
> = ({ researchAgent }) => (
  <AskAlpharunModal
    isOpen={researchAgent.isModalOpen}
    onOpenChange={researchAgent.onModalOpenChange}
    history={
      <ResearchAgentHistoryView
        surface="modalSidebar"
        resourceId={researchAgent.resourceId}
        selectedThreadId={researchAgent.threadId}
        onThreadSelect={researchAgent.onThreadSelect}
        onNewThreadSelect={() => researchAgent.onNewThreadSelect()}
      />
    }
  >
    <ResearchAgentChatView
      copilotChat={researchAgent}
      surface="modal"
      onRequestClose={researchAgent.onCloseChat}
    />
  </AskAlpharunModal>
);
